import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentRessources:null,
    furnituresCount:0,
    currentScenario:null,
    appReady:false,
    configuratorReady:false,
    loader:null,
    language:'en',
    infoOpened:false,
    isMobileDevice:false,
    podSize:"L"
  },
  mutations: {
    SET_LOADER(state, loader){
        state.loader = loader
    },
    SET_POD_SIZE(state, bool){
        state.podSize = bool
    },
    SET_MOBILE_DEVICE(state, bool){
        state.isMobileDevice = bool
    },
    SET_INFO_OPENED(state, bool){
        state.infoOpened = bool
    },
    SET_LANGUAGE(state, language){
        state.language = language
    },
    SET_FURNITURES_COUNT(state, count){
        state.furnituresCount = count
    },
    SET_APP_READY(state, bool){
        state.appReady = bool
    },
    SET_CONFIGURATOR_READY(state, bool){
        state.configuratorReady = bool
    },
    SET_CURRENT_SCENARIO(state, index){
        state.currentScenario = index
    }
  },
  actions: {
    setPodSize({commit},bool){
      commit("SET_POD_SIZE",bool);
    },
    setMobileDevice({commit},bool){
      commit("SET_MOBILE_DEVICE",bool);
    },
    setLoader({commit},loader){
      commit("SET_LOADER",loader)
    },
    setInfoOpened({commit},bool){
      commit("SET_INFO_OPENED",bool)
    },
    setLanguage({commit},language){
      commit("SET_LANGUAGE",language)
    },
    setFurnituresCount({commit}, count){
        commit("SET_FURNITURES_COUNT", count)
    },
    setAppReady({commit},bool){
      commit("SET_APP_READY",bool)
    },
    setConfiguratorReady({commit},bool){
      commit("SET_CONFIGURATOR_READY",bool)
    },
    setCurrentScenario({commit},index){
      commit("SET_CURRENT_SCENARIO",index)
    }
  },
  getters:{
      appReady : state => state.appReady,
      podSize : state => state.podSize,
      infoOpened : state => state.infoOpened,
      language : state => state.language,
      configuratorReady : state => state.configuratorReady,
      loader : state => state.loader,
      furnituresCount: state => state.furnituresCount,
      isMobileDevice: state => state.isMobileDevice,
      currentScenario: state => state.currentScenario
  }
})
